import React, {useState} from 'react'
import { Container, Fab, Typography } from '@material-ui/core'

import PersonAddIcon from '@material-ui/icons/PersonAdd'
import CreateIcon from '@material-ui/icons/Create'
import Join from './Join';
import Create from './Create';

function Home() {

    const [isJoin, setIsJoin] = useState(false)
    const [isCreate, setIsCreate] = useState(false)

    const clickJoin = ()=>{
        setIsCreate(false)
        setIsJoin(true)
    }
    const clickCreate = ()=>{
        setIsJoin(false)
        setIsCreate(true)
    }


    return (
        <div>
            <Container maxWidth="xs">

            
                <div style={{display: 'flex', justifyContent: 'space-around', margin:'15px', alignItems:'center'}}> 
                    <Fab variant="extended" onClick={clickJoin} color={isJoin ? "primary" : "default"}>
                        <PersonAddIcon />
                        Join
                    </Fab>

                    <Fab variant="extended" onClick={clickCreate} color={isCreate ? "primary" : "default"}>
                        <CreateIcon />
                        Create
                    </Fab> 
                </div>

                <div>
                    {
                        isJoin ? (
                            <Join />
                        ) :
                        isCreate ? (
                            <Create />
                        ) : ""
                    }
                </div>

                
            

            </Container>
            <Container maxWidth="sm"> 
                <div style={{marginTop:'30px'}}>
                    <Typography>Welcome to Paper chat.</Typography>
                    <br></br>
                    <Typography>This portal allows you to create a temporary chat room that will disappear after the last person leaves.</Typography>
                </div>
            </Container>
        </div>
    )
}

export default Home
